// src/components/PublicHeader.jsx
//import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Disclosure } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.png'; // Add your logo in src/assets

export default function PublicHeader() {
  const { user } = useAuth();
  const location = useLocation();
  const currentPath = location.pathname;

  const navLinks = [
    { label: 'Home', to: '/' },
    { label: 'Services', to: '/services' },
    { label: 'Projects', to: '/projects' },
    { label: 'Blog', to: '/blog' },
    { label: 'Careers', to: '/jobs' },
    { label: 'Contact', to: '/contact' },
  ];

  const isActive = (path) => currentPath === path;

  return (
    <Disclosure as="nav" className="sticky top-0 z-50 bg-primary text-white shadow-md">
      {({ open }) => (
        <>
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              {/* Logo + Brand */}
              <div className="flex min-w-0 items-center gap-2">
                <img src={logo} alt="ASTEM Software Lab logo" className="h-9 w-9 shrink-0 object-contain" />
                <Link to="/" className="min-w-0 truncate text-base font-bold tracking-wide text-white sm:text-xl">
                  ASTEM Software Lab
                </Link>
              </div>

              <div className="mx-2 block min-w-0 flex-1 overflow-hidden sm:mx-3 md:mx-5" aria-label="Featured services and projects">
                <div className="astem-header-marquee whitespace-nowrap text-center text-[8px] font-bold uppercase tracking-[0.12em] text-accent sm:text-[10px] sm:tracking-[0.16em] md:text-[11px] md:tracking-[0.2em]">
                  <span><span className="text-warm-amber">Custom Software</span> • <span className="text-accent">Digital Transformation</span> • <span className="text-emerald-300">Featured Projects</span> • <span className="text-orange-300">Cloud Solutions</span> • <span className="text-pink-300">Mobile Apps</span> • <span className="text-cyan-300">School Systems</span> • <span className="text-yellow-300">Business Analytics</span> • <span className="text-lime-300">Healthcare Technology</span> • <span className="text-fuchsia-300">Enterprise Tools</span> • <span className="text-sky-300">Digital Growth</span> • </span>
                  <span aria-hidden="true"><span className="text-warm-amber">Custom Software</span> • <span className="text-accent">Digital Transformation</span> • <span className="text-emerald-300">Featured Projects</span> • <span className="text-orange-300">Cloud Solutions</span> • <span className="text-pink-300">Mobile Apps</span> • <span className="text-cyan-300">School Systems</span> • <span className="text-yellow-300">Business Analytics</span> • <span className="text-lime-300">Healthcare Technology</span> • <span className="text-fuchsia-300">Enterprise Tools</span> • <span className="text-sky-300">Digital Growth</span> • </span>
                  <span className="ml-4"><span className="text-red-300">Hotel Management</span> • <span className="text-violet-300">Church Tools</span> • <span className="text-teal-300">DevOps &amp; Hosting</span> • <span className="text-rose-300">Secure Platforms</span> • <span className="text-slate-200">Future-Ready Tech</span> • </span>
                </div>
              </div>

              {/* Desktop Navigation */}
              <div className="hidden md:flex items-center space-x-6 text-sm">
                {navLinks.map(({ label, to }) => (
                  <Link
                    key={to}
                    to={to}
                    className={`hover:text-accent transition ${
                      isActive(to) ? 'text-accent font-semibold' : 'text-white'
                    }`}
                  >
                    {label}
                  </Link>
                ))}

                {user && (
                  <Link to="/dashboard" className="bg-white text-primary px-4 py-2 rounded hover:bg-accent hover:text-white">
                    Dashboard
                  </Link>
                )}
              </div>

              {/* Mobile menu button */}
              <div className="md:hidden flex items-center">
                <Disclosure.Button
                  className="inline-flex h-9 w-9 items-center justify-center rounded-full text-white transition hover:bg-white/10 hover:text-accent focus:outline-none focus:ring-2 focus:ring-white/60"
                  aria-label={open ? 'Close navigation menu' : 'Open navigation menu'}
                >
                  {open ? <XMarkIcon className="h-5 w-5" /> : <Bars3Icon className="h-5 w-5" />}
                </Disclosure.Button>
              </div>
            </div>
          </div>

          {/* Mobile Navigation */}
          <Disclosure.Panel className="max-h-[calc(100dvh-4rem)] touch-pan-y overflow-y-auto overscroll-contain border-t border-white/10 bg-primary px-3 pb-4 pt-2 shadow-xl [-webkit-overflow-scrolling:touch] md:hidden">
            {navLinks.map(({ label, to }) => (
              <Disclosure.Button
                as={Link}
                key={to}
                to={to}
                className={`block rounded-full px-3 py-2 text-sm font-semibold transition ${
                  isActive(to) ? 'bg-accent text-white' : 'text-white hover:bg-white hover:text-primary'
                }`}
              >
                {label}
              </Disclosure.Button>
            ))}
            {user && (
              <Disclosure.Button
                as={Link}
                to="/dashboard"
                className="mt-2 block rounded-full bg-white px-3 py-2 text-center text-sm font-bold text-primary"
              >
                Dashboard
              </Disclosure.Button>
            )}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
